import React from 'react';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const BookNewSessionFab = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  return (
    <Fab
      color="primary"
      variant="extended"
      sx={{
        position: 'fixed',
        bottom: isSmallScreen ? 16 : 24,
        right: 24,
        left: isSmallScreen ? 32 : 'auto',
        textTransform: 'none',
        minHeight: isSmallScreen ? 52 : 48,
        paddingBottom: 'env(safe-area-inset-bottom)',
        zIndex: 1000,
      }}
      onClick={() => navigate('/passes/schedule')}>
      <AddIcon sx={{ mr: 1 }} />
      {t('manage_passes.dashboard.bookNewSession')}
    </Fab>
  );
};
